import React from 'react';
import { Link } from 'react-router-dom';
import './Pages/PagesCss/Footer.css';
import logo from './assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="CreditsIQ Logo" className="logo" />
              <span className="footer-logo-text">CreditsIQ</span>
            </div>
            <p className="footer-description">
              Empowering your financial journey with intelligent credit analysis, 
              smart calculators, and personalized financial insights.
            </p>
            <div className="footer-social">
              <a 
  href="https://www.facebook.com/people/D-Tech-Studios/61556107977536" 
  className="social-link" 
  aria-label="Facebook" 
  target="_blank" 
  rel="noopener noreferrer"
>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://x.com/D_TechStudios"
                   className="social-link" 
  aria-label="Twitter" 
  target="_blank" 
  rel="noopener noreferrer"
>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/d-tech-studios?trk=public_post_follow-view-profile"
                  className="social-link" 
  aria-label="LinkedIn" 
  target="_blank" 
  rel="noopener noreferrer"
>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/d_techstudios/"
                  className="social-link" 
  aria-label="Instagram" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10zm-5 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm4.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
  </svg>
</a>

            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <div className="footer-column">
              <h3 className="footer-column-title">Credit Tools</h3>
              <ul className="footer-link-list">
                <li><Link to="/CreditCardPayoffCalculator" className="footer-link">Credit Management</Link></li>
                <li><Link to="/BalanceTransferCalculator" className="footer-link">Credit Savings</Link></li>
                <li><Link to="/CreditUtilizationCalculator" className="footer-link">Credit Calculator</Link></li>
                <li><Link to="/CardApprovalOddsChecker" className="footer-link">Credit Planning</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-column-title">Navigation</h3>
              <ul className="footer-link-list">
                <li><Link to="/" className="footer-link">Home</Link></li>
                <li><Link to="/About" className="footer-link">About</Link></li>
                <li><Link to="/Contact" className="footer-link">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-column-title">Legal</h3>
              <ul className="footer-link-list">
                <li><Link to="/PrivacyPolicy" className="footer-link">Privacy Policy</Link></li>
                <li><Link to="/TermsCondition" className="footer-link">Terms of Service</Link></li>
                <li><Link to="/Disclaimer" className="footer-link">Disclaimer</Link></li>
                <li><Link to="/ContentPolicy" className="footer-link">Content Policy</Link></li>
                <li><Link to="/CookiePolicy" className="footer-link">Cookie Policy</Link></li>
                <li>
                  <a href="/sitemap.xml" className="footer-link" target="_blank" rel="noopener noreferrer">
                    Sitemap
                  </a>
                </li>
              </ul>
            </div>

           <div className="footer-column">
  <h3 className="footer-column-title">
    Explore Our Platforms
  </h3>
  <ul className="footer-link-list">
    <li>
      <a 
        href="https://d-techstudios.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="footer-link"
      >
        D-Techstudios
      </a>
    </li>
    <li>
      <a 
        href="https://cryptomux.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="footer-link"
      >
        Cryptomux
      </a>
    </li>
    <li>
      <a 
        href="https://noobtobull.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="footer-link"
      >
        NoobToBull
      </a>
    </li>
    <li>
      <a 
        href="https://aftertaxpay.net/" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="footer-link"
      >
        AfterTaxPay
      </a>
    </li>
    <li>
      <a 
        href="https://aipicks.org" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="footer-link"
      >
        Aipicks
      </a>
    </li>
    <li>
      <a 
        href="https://font-max.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="footer-link"
      >
        Font-Max
      </a>
    </li>
  </ul>
</div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; {currentYear} CreditsIQ. All rights reserved.</p>
            </div>
            <div className="footer-legal">
              <Link to="/PrivacyPolicy" className="footer-legal-link">Privacy Policy</Link>
              <span className="footer-separator">|</span>
              <Link to="/TermsCondition" className="footer-legal-link">Terms of Service</Link>
              <span className="footer-separator">|</span>
              <Link to="/CookiePolicy" className="footer-legal-link">Cookie Policy</Link>
            </div>
            <div className="footer-badges">
              <div className="security-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
                </svg>
                <span>SSL Secured</span>
              </div>
              <div className="security-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
                <span>GDPR Compliant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;